import React, {useEffect, useState} from 'react';
import {Replacement} from '../../interface';
import {OilVolumesService} from '../OilVolumesService';
import localesReplacement from '../../utils/localesReplacement';
import Loading from '../Loading';
import DOMPurify from 'dompurify';
import classnames from 'classnames/bind';
import style from './index.module.scss';

import { useSelector } from 'react-redux';

interface IProps {
  notes: Array<string>;
  replacements: Replacement;
}

const cx = classnames.bind(style);

export const FailedRecommendation = (props: IProps) => {
  const {notes, replacements} = props;
  const [message, setMessage] = useState('');

  const country = useSelector((state: any) => state.country);
  const countryCode = country.isoCode;
  const loadSpecialProduct = async () => {
    if (
      !['AUS', 'NZL'].includes(countryCode) ||
        (['AUS', 'NZL'].includes(countryCode) && !props.notes) ||
        props?.notes?.length === 0
    ) {
      if (countryCode === 'ARE') {
        setMessage("Please contact your local dealership workshop to get a suitable recommendation");
      }
      else if (countryCode === 'GBR') {
        setMessage("We apologise we do not have specific product information at this time. Please consult your owner’s manual for product recommendations for your vehicle.");
      }
      else if (countryCode === 'MYS' || countryCode === 'SGP') {
        setMessage("Please consult Castrol representative.");
    }
      else {
        setMessage(localesReplacement(
            replacements,
            'No recommended products for this vehicle.',
        ));
      }
    }
  };
  useEffect(() => {
    loadSpecialProduct();
  }, [countryCode]);

  return (
    <>
      {!message && props?.notes?.length === 0 && <Loading data-testid = "loading-element"  />}
      {(message || props?.notes?.length > 0) && (
        <div className={cx('no-content')}>
          <div
            dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(message)}}
          ></div>
          <div>
            <br />
            <OilVolumesService data-testid = "oil-volumes-service"
              notes={notes ? notes : []}
              withoutMoreLink={true}
              replacements={replacements}
            />
          </div>
        </div>
      )}
    </>
  );
};
